import React, { useEffect, useRef, useState } from 'react';

import TextField from 'app/commonComponents/TextField';
import { useUpdateEffect } from 'app/hooks';
import { EyeClosedIcon, EyeIcon } from 'app/commonComponents/icons';

function PasswordInput(props) {
  const [show, setShow] = useState(false);
  const inputRef = useRef();
  useUpdateEffect(() => {
    inputRef.current.focus();
  }, [show]);
  return (
    <div style={{ position: 'relative' }}>
      <TextField
        inputRef={inputRef}
        type={show ? 'text' : 'password'}
        {...props}
      />
      <span
        style={{
          cursor: 'pointer',
          position: 'absolute',
          right: '2px',
          bottom: '3px',
        }}
        onClick={() => setShow(!show)}
      >
        {show ? <EyeIcon /> : <EyeClosedIcon />}
      </span>
    </div>
  );
}

PasswordInput.propTypes = {
  ...TextField.propTypes,
};

export default PasswordInput;
